// extracted by mini-css-extract-plugin
export default {"options":"CountryLabel_options__mV80c","name":"CountryLabel_name__2toM4"};